// Copyright (c) Microsoft Corporation. All rights reserved.
/**
 * Stream readiness status changed event.
 */
export class StreamReadinessStatusChangedEvent extends Event {
    constructor() {
        super(StreamReadinessStatusChangedEvent.type);
    }
}
StreamReadinessStatusChangedEvent.type = 'streamReadinessStatusChanged';
//# sourceMappingURL=StreamReadinessStatusChangedEvent.js.map